import axios from 'axios';

import { authService } from './auth-service';

export default ({
  client,
  campaignId,
  campaignName,
  organisationId,
  invitation,
}) => {
  const invite = client.create('campaignInvitation');

  invite.set('name', invitation.name);
  invite.set('campaign', {
    type: 'campaigns',
    id: campaignId,
  });
  invite.set('organisation', {
    type: 'organisations',
    id: organisationId,
  });
  invite.set('campaignName', campaignName);
  invite.set('role', invitation.role);
  invite.set('status', invitation.status || 'SENT');
  const { origin } = window.location;
  invite.set('origin', origin);
  invite.set('link', `${origin}/invite/`);

  if (invitation.email) {
    invite.set('email', invitation.email);
  }

  if (invitation.role === 'INFLUENCER') {
    invite.set('metadata', {
      instagram: invitation.instagram,
      socialHandle: invitation.primarySocialHandle,
      influencerId: invitation.id,
    });
  }

  return invite.sync().then(ci => {
    const newInvitation = ci.toJSON();
    const ax = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 30000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
    return ax.post(`/campaigns/${campaignId}/relationships/pendingInvitations/`, {
      data: {
        type: 'campaignInvitation',
        id: newInvitation.id,
      },
    }).then(() => newInvitation);
  });
};



/** WEBPACK FOOTER **
 ** ./src/utils/invite-creator-to-campaign.js
 **/